// extracted by mini-css-extract-plugin
export default {"social-media-links":"jV5nBEx","social-media-links__list":"qzsmwPm","social-media-links__item":"ReNeBL2"};